<div [id]="data.widgetId" 
  style="width: 100%;"
  [style.height]="data?.chartHeight || data?.chartConfig?.chartHeight || data?.chartConfig?.chartheight || '300px'">
</div>
